<template>
	<div :class="'ks-videoeditor-split-' + direction" @mousedown.prevent="start"></div>
</template>

<script>
// Drag handle between two panels; reports the pointer offset since the drag started
export default {
	props: {
		// "v" is a vertical bar (resizes widths), "h" a horizontal one (resizes heights)
		direction: {type: String, default: "v"}
	},
	beforeDestroy () {
		this.detach();
	},
	methods: {
		start (event) {
			this.origin = {x: event.clientX, y: event.clientY};
			window.addEventListener("mousemove", this.move);
			window.addEventListener("mouseup", this.end);
			this.$emit("start");
		},
		move (event) {
			this.$emit("move", {dx: event.clientX - this.origin.x, dy: event.clientY - this.origin.y});
		},
		end () {
			this.detach();
			this.$emit("end");
		},
		detach () {
			window.removeEventListener("mousemove", this.move);
			window.removeEventListener("mouseup", this.end);
		}
	}
}
</script>

<style scoped>
.ks-videoeditor-split-v, .ks-videoeditor-split-h { flex: none; display: flex; align-items: center; justify-content: center; opacity: 0.5; }
.ks-videoeditor-split-v:hover, .ks-videoeditor-split-h:hover { opacity: 1; }
.ks-videoeditor-split-v { cursor: col-resize; }
.ks-videoeditor-split-h { height: 12px; cursor: row-resize; }
.ks-videoeditor-split-v::after { content: ""; width: 3px; height: 40px; border-radius: 2px; background: var(--ks-col-secondary, #888); }
.ks-videoeditor-split-h::after { content: ""; height: 3px; width: 40px; border-radius: 2px; background: var(--ks-col-secondary, #888); }
</style>
